import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { changeWeightAutoStatus, delEditManualScheme, editManualScheme, editPaymentLimitInfo, editWeightAllInOne, editWeightMerchantInfo, getChannelMaxCost, getMethodList, getNowWeightList, getPayLimitInfo, getPayWeight, getSuccessRateLimit, getWeightMerchantInfo, getWeightStatus, setChannelMaxCost, showEditManualScheme, successRateLimit } from "@/api/payment";
import { getChannelList, gteChannelItem } from "@/api/channel";
import draggable from "vuedraggable";
import { getMerchantAllList } from "@/api/merchant";
export default {
  name: "Channel",
  components: {
    draggable: draggable
  },
  data: function data() {
    return {
      weightNumber: 0,
      tableKey: 0,
      type: 0,
      showAuto: null,
      showType: null,
      originalTableData: {},
      tableData: [],
      maxCash: null,
      addOneChannel: [],
      selectAddChannl: [],
      editOneSuccessRateMethod: "",
      newSchemeName: "",
      editSuccessRate: {
        list: [],
        type: 0
      },
      editOneSuccessRate: [],
      editWeight: {
        list: [],
        type: 0
      },
      editOneWeight: [],
      channelsList: [],
      methodList: [],
      weightList: [],
      addHandWeight: false,
      optionName: "",
      handWeightOption: [],
      handWeightOptionOnce: "",
      handWeightOptionData: {},
      notManyWeight: [],
      yesManyWeight: [],
      yesMerchantWeight: [],
      displayAddEditManyWeight: false,
      editManyWeight: [],
      editManyWeightBotton: false,
      manyWeightDialog: false,
      manyWeightVisible: false,
      successRateVisible: false,
      availableChannlVisble: false,
      displayindex: "",
      merchantWeightDialog: false,
      merchantIdList: [],
      timer: null,
      groupA: {
        name: "itxst",
        pull: false,
        // 可以拖出
        put: true // 可以拖入
      },
      grouptable: {
        name: "table",
        pull: false,
        put: true
      },
      grouptableA: {
        name: "table",
        pull: "clone",
        put: false
      }
    };
  },
  watch: {
    editManyWeightBotton: function editManyWeightBotton(newValue, oldValue) {
      var _this = this;
      if (newValue) {
        setTimeout(function () {
          _this.editManyWeightBotton = false;
        }, 1000);
      }
    }
  },
  created: function created() {
    // this.getNotice();
    this.getMethod();
    this.getStatus();
    this.getChannls();
    this.getMerchantIdList();
    this.getMerchantWeightInfo();
    // this.getPullUpTime()
  },
  destroyed: function destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    getStatus: function getStatus() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return getWeightStatus();
            case 1:
              res = _context.sent;
              if (!(res.code === 0)) {
                _context.next = 2;
                break;
              }
              _this2.type = res.data.payInStatus === "自动模式" ? 1 : 0;
              _context.next = 2;
              return _this2.switchData(_this2.type);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    /** @description 获取商户ID列表 */getMerchantIdList: function getMerchantIdList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return getMerchantAllList();
            case 1:
              res = _context2.sent;
              if (res.code === 0) {
                _this3.merchantIdList = res.data;
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    /** @description 获取自动的表格 */getVoluntarilyTable: function getVoluntarilyTable() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, tableData, tableDataKey, k, tableObj, i, level, channels, j, obj;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return getSuccessRateLimit();
            case 1:
              res = _context3.sent;
              if (res.code === 0) {
                tableData = res.data.listMap;
                _this4.originalTableData = tableData;
                if (_this4.type === 1 || _this4.showAuto === 1) {
                  _this4.tableData = [];
                  tableDataKey = Object.keys(tableData);
                  for (k = 0; k < tableDataKey.length; k++) {
                    tableObj = {
                      method: tableDataKey[k],
                      list: []
                    };
                    for (i = 0; i < tableData[tableDataKey[k]].length; i++) {
                      level = tableData[tableDataKey[k]][i].min + "% ~ " + tableData[tableDataKey[k]][i].max + "%";
                      channels = tableData[tableDataKey[k]][i].channels;
                      if (channels.length === 0) {
                        tableObj.list.push({
                          level: level,
                          weight: tableData[tableDataKey[k]][i].weight
                        });
                      }
                      for (j = 0; j < channels.length; j++) {
                        channels[j].pullUpRate = channels[j].pullUpRate ? channels[j].pullUpRate : "/";
                        channels[j].notifyRate = channels[j].notifyRate ? channels[j].notifyRate : "/";
                        channels[j].totalRate = channels[j].totalRate ? channels[j].totalRate : "/";
                        obj = _objectSpread({
                          level: level,
                          weight: tableData[tableDataKey[k]][i].weight,
                          method: tableDataKey[k]
                        }, channels[j]);
                        tableObj.list.push(obj);
                      }
                    }
                    _this4.tableData.push(tableObj);
                  }
                }
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getChannls: function getChannls() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.channelsList = [];
              _context4.next = 1;
              return getChannelMaxCost({
                type: 0
              });
            case 1:
              res = _context4.sent;
              if (res.code === 0) {
                _this5.channelsList = res.data.list;
              }
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getMethod: function getMethod() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return getMethodList();
            case 1:
              res = _context5.sent;
              if (res.code === 0) {
                _this6.methodList = res.data;
              }
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    /** @description 获取手动表格 */getHandWeight: function getHandWeight() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res, tableData, tableDataKey, i, tableObj, j;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.tableData = [];
              res = null;
              tableData = null;
              if (!(_this7.showAuto === 3)) {
                _context6.next = 2;
                break;
              }
              _context6.next = 1;
              return getNowWeightList({
                type: 0
              });
            case 1:
              res = _context6.sent;
              _context6.next = 4;
              break;
            case 2:
              _context6.next = 3;
              return getPayWeight({
                type: 0
              });
            case 3:
              res = _context6.sent;
            case 4:
              if (res.code === 0) {
                tableData = _this7.showAuto === 3 ? res.data : res.data.listMap;
                tableDataKey = Object.keys(tableData);
                for (i = 0; i < tableDataKey.length; i++) {
                  tableObj = {
                    method: tableDataKey[i],
                    list: []
                  };
                  for (j = 0; j < tableData[tableDataKey[i]].length; j++) {
                    tableData[tableDataKey[i]][j]["number"] = j;
                    if (tableData[tableDataKey[i]][j].hasOwnProperty("notifyRate")) {
                      tableData[tableDataKey[i]][j].notifyRate = tableData[tableDataKey[i]][j].notifyRate ? tableData[tableDataKey[i]][j].notifyRate : "/";
                    }
                    if (tableData[tableDataKey[i]][j].hasOwnProperty("pullUpRate")) {
                      tableData[tableDataKey[i]][j].pullUpRate = tableData[tableDataKey[i]][j].pullUpRate ? tableData[tableDataKey[i]][j].pullUpRate : "/";
                    }
                    tableObj.list.push(tableData[tableDataKey[i]][j]);
                  }
                  _this7.tableData.push(tableObj);
                }
              }
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    /** @description 获取多套手动表格 */getManyHandWeight: function getManyHandWeight() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this8.editManyWeightBotton = true;
              _this8.optionName = "";
              _this8.addHandWeight = false;
              _context7.next = 1;
              return showEditManualScheme({
                type: 0
              });
            case 1:
              res = _context7.sent;
              if (res.code === 0) {
                _this8.handWeightOption = Object.keys(res.data.list);
                if (_this8.handWeightOptionOnce === "") {
                  _this8.handWeightOptionOnce = _this8.handWeightOption[0];
                  _this8.editManyWeightBotton = false;
                }
                _this8.manyWeightVisible = true;
                _this8.handWeightOptionData = res.data.list;
                if (Object.keys(_this8.handWeightOptionData).length >= 0) {
                  _this8.handWeightOptionSelect();
                } else {
                  _this8.yesManyWeight = [];
                }
              }
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    /** @description 获取商户 */showMerchantChannel: function showMerchantChannel() {
      this.notManyWeight = [];
      this.yesManyWeight = [];
      this.editManyWeightBotton = true;
      for (var i = 0; i < this.tableData.length; i++) {
        for (var j = 0; j < this.tableData[i].list.length; j++) {
          var obj = {};
          obj["channel"] = this.tableData[i].list[j].channel;
          obj["channelStr"] = this.tableData[i].list[j].channelStr;
          obj["payKey"] = this.tableData[i].list[j].payKey;
          obj["method"] = this.tableData[i].method;
          obj["weight"] = 0;
          this.notManyWeight.push(obj);
        }
      }
      this.merchantWeightDialog = true;
    },
    /** @description 获取每个商户的信息 */getMerchantWeightInfo: function getMerchantWeightInfo() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res, key, obj, key1, i, objChannl;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this9.yesMerchantWeight = [];
              _context8.next = 1;
              return getWeightMerchantInfo();
            case 1:
              res = _context8.sent;
              if (res.code === 0) {
                for (key in res.data.list) {
                  obj = {
                    MerchantID: key,
                    channels: []
                  };
                  for (key1 in res.data.list[key]) {
                    for (i = 0; i < res.data.list[key][key1].length; i++) {
                      objChannl = {
                        channel: res.data.list[key][key1][i].Channel,
                        channelStr: res.data.list[key][key1][i].channelStr,
                        payKey: res.data.list[key][key1][i].PayKey,
                        method: res.data.list[key][key1][i].Method,
                        weight: res.data.list[key][key1][i].Weight
                      };
                      obj.channels.push(objChannl);
                    }
                  }
                  _this9.yesMerchantWeight.push(obj);
                }
              }
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    /** @description 提取多套手动的其中一套 */handWeightOptionSelect: function handWeightOptionSelect() {
      this.yesManyWeight = this.formateMantWeightData(this.handWeightOptionData[this.handWeightOptionOnce]);
    },
    /** @description 添加新方案 */addNewManyWeight: function addNewManyWeight() {
      this.displayAddEditManyWeight = true;
      this.yesManyWeight = [];
    },
    addHandWeightOptiontPre: function addHandWeightOptiontPre() {
      this.addHandWeight = true;
      this.tableData = [];
    },
    /** @description 修改表格内容 */editWeightfn: function editWeightfn(f) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var i, k, reg, res, _res;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this0.editWeight = {
                list: [],
                type: 0
              };
              i = 0;
            case 1:
              if (!(i < _this0.tableData.length)) {
                _context9.next = 8;
                break;
              }
              k = 0;
            case 2:
              if (!(k < _this0.tableData[i].list.length)) {
                _context9.next = 7;
                break;
              }
              if (!_this0.addHandWeight) {
                _context9.next = 5;
                break;
              }
              if (_this0.optionName) {
                _context9.next = 3;
                break;
              }
              _this0.$message.warning("方案名字不能为空");
              return _context9.abrupt("return");
            case 3:
              reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
              if (!reg.test(_this0.optionName)) {
                _context9.next = 4;
                break;
              }
              _this0.$message.warning("方案名字里不能有中文");
              return _context9.abrupt("return");
            case 4:
              _this0.tableData[i].list[k]["schemeName"] = _this0.optionName;
            case 5:
              _this0.tableData[i].list[k]["method"] = _this0.tableData[i].method;
              _this0.editWeight.list.push(_this0.formatWeight(_this0.tableData[i].list[k]));
            case 6:
              k++;
              _context9.next = 2;
              break;
            case 7:
              i++;
              _context9.next = 1;
              break;
            case 8:
              if (!((_this0.addHandWeight || _this0.showAuto === 4) && f !== 1)) {
                _context9.next = 11;
                break;
              }
              _context9.next = 9;
              return editManualScheme(_this0.editWeight);
            case 9:
              res = _context9.sent;
              if (!(res.code === 0)) {
                _context9.next = 10;
                break;
              }
              _this0.editWeight = {
                list: [],
                type: 0
              };
              if (_this0.addHandWeight) {
                _this0.handWeightOptionOnce = _this0.optionName;
                _this0.$message.success("方案添加成功");
              } else {
                _this0.$message.success("方案修改成功");
              }
              _this0.editWeight = {
                list: [],
                type: 0
              };
              _context9.next = 10;
              return _this0.getManyHandWeight();
            case 10:
              _context9.next = 15;
              break;
            case 11:
              _context9.next = 12;
              return editWeightAllInOne(_this0.editWeight);
            case 12:
              _res = _context9.sent;
              if (!(_res.code === 0)) {
                _context9.next = 15;
                break;
              }
              _this0.editWeight = {
                list: [],
                type: 0
              };
              _this0.$message.success("修改成功");
              _this0.editWeight = {
                list: [],
                type: 0
              };
              if (!(_this0.showAuto === 4)) {
                _context9.next = 14;
                break;
              }
              _context9.next = 13;
              return _this0.getManyHandWeight();
            case 13:
              _context9.next = 15;
              break;
            case 14:
              _context9.next = 15;
              return _this0.getHandWeight();
            case 15:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    /** @description 编辑可用通道 */editAvailable: function editAvailable() {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        var res;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.next = 1;
              return setChannelMaxCost({
                list: _this1.channelsList,
                type: 0
              });
            case 1:
              res = _context0.sent;
              if (res.code === 0) {
                _this1.$message.success(res.msg);
              }
              _context0.next = 2;
              return _this1.getChannls();
            case 2:
            case "end":
              return _context0.stop();
          }
        }, _callee0);
      }))();
    },
    /** @description 删除通道 */removeAvailableChannle: function removeAvailableChannle(index) {
      var _this10 = this;
      this.$confirm("将此通道移除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this10.channelsList.splice(index, 1);
        _this10.editAvailable();
      }).catch(function () {
        _this10.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    deleteAutoChannl: function deleteAutoChannl(index, index1) {
      var _this11 = this;
      this.$confirm("将此通道移除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this11.editOneSuccessRate[index].channels.splice(index1, 1);
        _this11.$message({
          type: "success",
          message: "删除成功!"
        });
      }).catch(function () {
        _this11.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    deleteUnAutoChannl: function deleteUnAutoChannl(method, idx) {
      var _this12 = this;
      this.$confirm("将此通道移除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        for (var i = 0; i < _this12.tableData.length; i++) {
          if (method === _this12.tableData[i].method) {
            _this12.tableData[i].list.splice(idx, 1);
          }
        }
        _this12.$message({
          type: "success",
          message: "请点击表格修改完成按钮，完成删除"
        });
      }).catch(function () {
        _this12.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    /** @description 删除方案 */handWeightOptiondelete: function handWeightOptiondelete() {
      var _this13 = this;
      this.$confirm("将此方案删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
        var res;
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _context1.next = 1;
              return delEditManualScheme({
                type: 0,
                schemeName: _this13.handWeightOptionOnce
              });
            case 1:
              res = _context1.sent;
              if (!(res.code === 0)) {
                _context1.next = 2;
                break;
              }
              _this13.$message({
                type: "success",
                message: "已删除此方案"
              });
              _this13.handWeightOptionOnce = "";
              _context1.next = 2;
              return _this13.getManyHandWeight();
            case 2:
            case "end":
              return _context1.stop();
          }
        }, _callee1);
      }))).catch(function () {
        _this13.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    /** @description 切换模式 */switchMode: function switchMode() {
      var _this14 = this;
      this.$confirm("将模式切换为" + (this.type === 0 ? "自动" : "手动") + ", 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var res;
        return regeneratorRuntime.wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 1;
              return changeWeightAutoStatus({
                payType: 0,
                status: _this14.type === 0 ? 1 : 0
              });
            case 1:
              res = _context10.sent;
              if (!(res.code === 0)) {
                _context10.next = 3;
                break;
              }
              _context10.next = 2;
              return _this14.getStatus();
            case 2:
              _this14.$message({
                type: "success",
                message: "切换模式成功"
              });
              _context10.next = 4;
              break;
            case 3:
              _this14.$message({
                type: "danger",
                message: "切换模式失败"
              });
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))).catch(function () {
        _this14.$message({
          type: "info",
          message: "已取消切换"
        });
      });
    },
    /** @description 切换数据 */switchData: function switchData(idx) {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function (_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (idx === 3 || idx === 4) {
                _this15.showAuto = idx;
              } else {
                _this15.showAuto = idx;
                if (_this15.type !== 1) {
                  _this15.showType = _this15.showAuto === 0 ? 1 : 0;
                } else {
                  _this15.showAuto = 1;
                }
              }
              if (!(_this15.showAuto === 0 || _this15.showAuto === 3)) {
                _context11.next = 2;
                break;
              }
              _context11.next = 1;
              return _this15.getHandWeight();
            case 1:
              _context11.next = 5;
              break;
            case 2:
              if (!(_this15.showAuto === 4)) {
                _context11.next = 4;
                break;
              }
              _context11.next = 3;
              return _this15.getManyHandWeight();
            case 3:
              _context11.next = 5;
              break;
            case 4:
              _context11.next = 5;
              return _this15.getVoluntarilyTable();
            case 5:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    /** @description 打开修改成功率弹出框 */openSuccessRateDialog: function openSuccessRateDialog(channl) {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var tableDataKey, i, channlList, k, channels, channelsList, j;
        return regeneratorRuntime.wrap(function (_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              tableDataKey = Object.keys(_this16.originalTableData);
              _this16.editOneSuccessRateMethod = channl;
              for (i = 0; i < tableDataKey.length; i++) {
                channlList = _this16.originalTableData[tableDataKey[i]];
                for (k = 0; k < channlList.length; k++) {
                  channels = [];
                  channelsList = channlList[k].channels;
                  channlList[k].method = tableDataKey[i];
                  if (tableDataKey[i] === channl) {
                    _this16.editOneSuccessRate = _this16.originalTableData[tableDataKey[i]];
                  } else {
                    for (j = 0; j < channelsList.length; j++) {
                      channels.push(_this16.formatSuccessRate(channelsList[j]));
                    }
                    channlList[k].channels = channels;
                    _this16.editSuccessRate.list.push(channlList[k]);
                  }
                }
              }
              _this16.successRateVisible = true;
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    showAvailableChannlDialog: function showAvailableChannlDialog() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var res, addChannlKey, i, obj;
        return regeneratorRuntime.wrap(function (_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 1;
              return getChannelList();
            case 1:
              res = _context13.sent;
              if (res.code === 0) {
                addChannlKey = Object.keys(res.data);
                for (i = 0; i < addChannlKey.length; i++) {
                  obj = {
                    ID: res.data[addChannlKey[i]],
                    channel: parseInt(addChannlKey[i]),
                    select: {
                      ID: res.data[addChannlKey[i]],
                      channel: parseInt(addChannlKey[i])
                    },
                    children: []
                  };
                  _this17.selectAddChannl.push(obj);
                  _this17.availableChannlVisble = true;
                }
              }
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    showManyWeight: function showManyWeight(flag) {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var i, j, obj, res;
        return regeneratorRuntime.wrap(function (_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this18.manyWeightDialog = flag;
              _this18.notManyWeight = [];
              _this18.yesManyWeight = [];
              _this18.editManyWeightBotton = true;
              for (i = 0; i < _this18.tableData.length; i++) {
                for (j = 0; j < _this18.tableData[i].list.length; j++) {
                  if (_this18.tableData[i].list[j].weight !== 0) {
                    obj = {};
                    obj["channel"] = _this18.tableData[i].list[j].channel;
                    obj["channelStr"] = _this18.tableData[i].list[j].channelStr;
                    obj["payKey"] = _this18.tableData[i].list[j].payKey;
                    obj["method"] = _this18.tableData[i].method;
                    obj["falg"] = false;
                    obj["payOutLimitWeight"] = 0;
                    _this18.notManyWeight.push(obj);
                  }
                }
              }
              if (!flag) {
                _context14.next = 2;
                break;
              }
              _context14.next = 1;
              return _this18.getManyHandWeight();
            case 1:
              _context14.next = 4;
              break;
            case 2:
              _context14.next = 3;
              return getPayLimitInfo();
            case 3:
              res = _context14.sent;
              if (res.code === 0) {
                _this18.yesManyWeight = _this18.formateMantWeightData(res.data.list);
                _this18.editManyWeightBotton = false;
                _this18.manyWeightVisible = true;
              } else {
                _this18.editManyWeightBotton = false;
              }
            case 4:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    /**  @description 多权重数据格式化 */formateMantWeightData: function formateMantWeightData(obj) {
      console.log(obj);
      var arr = [];
      var objKey = Object.keys(obj);
      for (var i = 0; i < objKey.length; i++) {
        var oneObj = {};
        var manyWeiWeightLimt = objKey[i].split("_");
        oneObj["payOutLimitStart"] = Number(manyWeiWeightLimt[0]);
        oneObj["payOutLimitEnd"] = Number(manyWeiWeightLimt[1]);
        oneObj["channels"] = [];
        var oneObjKey = Object.keys(obj[objKey[i]]);
        for (var j = 0; j < oneObjKey.length; j++) {
          for (var k = 0; k < obj[objKey[i]][oneObjKey[j]].length; k++) {
            obj[objKey[i]][oneObjKey[j]][k]["falg"] = true;
            if (this.displayAddEditManyWeight) {
              oneObj["schemeName"] = this.newSchemeName;
            }
            if (this.manyWeightDialog && obj[objKey[i]][oneObjKey[j]][0].schemeName) {
              oneObj["schemeName"] = obj[objKey[i]][oneObjKey[j]][0].schemeName;
            }
          }
          oneObj["channels"] = [].concat(_toConsumableArray(oneObj["channels"]), _toConsumableArray(obj[objKey[i]][oneObjKey[j]]));
        }
        arr.push(oneObj);
      }
      return arr;
    },
    deleteLimitChannl: function deleteLimitChannl(index, index1) {
      var _this19 = this;
      this.$confirm("将此通道移除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this19.yesManyWeight[index].channels.splice(index1, 1);
        _this19.$message({
          type: "success",
          message: "删除成功!"
        });
      }).catch(function () {
        _this19.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    deleteMerchantWightChannl: function deleteMerchantWightChannl(index, index1) {
      var _this20 = this;
      this.$confirm("将此通道移除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this20.yesMerchantWeight[index].channels.splice(index1, 1);
        _this20.$message({
          type: "success",
          message: "删除成功!"
        });
      }).catch(function () {
        _this20.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    addLimitRate: function addLimitRate() {
      var obj = {
        channels: [],
        payOutLimitEnd: 0,
        payOutLimitStart: 0
      };
      this.yesManyWeight.push(obj);
    },
    addMerchantWight: function addMerchantWight() {
      var obj = {
        MerchantID: "",
        channels: []
      };
      this.yesMerchantWeight.push(obj);
    },
    /** @description 添加, 修改多权重模式 */addLastLimitRate: function addLastLimitRate(flag) {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var res, lastData, objKey, reg, i, _objKey, _i;
        return regeneratorRuntime.wrap(function (_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this21.editManyWeightBotton = true;
              if (!(_this21.yesManyWeight.length <= 0)) {
                _context15.next = 1;
                break;
              }
              _this21.$message.warning("方案内容不能为空");
              return _context15.abrupt("return");
            case 1:
              if (!(_this21.manyWeightDialog && !flag)) {
                _context15.next = 9;
                break;
              }
              lastData = []; // 多套多权重修改
              if (!_this21.displayAddEditManyWeight) {
                _context15.next = 6;
                break;
              }
              // 添加新方案
              objKey = Object.keys(_this21.handWeightOptionData);
              if (_this21.newSchemeName) {
                _context15.next = 2;
                break;
              }
              _this21.$message.warning("方案名字不能为空");
              return _context15.abrupt("return");
            case 2:
              reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
              if (!reg.test(_this21.newSchemeName)) {
                _context15.next = 3;
                break;
              }
              _this21.$message.warning("方案名字里不能有中文");
              return _context15.abrupt("return");
            case 3:
              for (i = 0; i < objKey.length; i++) {
                lastData.push.apply(lastData, _toConsumableArray(_this21.formartEditWeight(_this21.formateMantWeightData(_this21.handWeightOptionData[objKey[i]]))));
              }
              if (!(_this21.yesManyWeight.length > 0)) {
                _context15.next = 5;
                break;
              }
              lastData.push.apply(lastData, _toConsumableArray(_this21.formartEditWeight(_this21.yesManyWeight)));
              _context15.next = 4;
              return editManualScheme({
                list: lastData,
                type: 0
              });
            case 4:
              res = _context15.sent;
            case 5:
              _context15.next = 8;
              break;
            case 6:
              delete _this21.handWeightOptionData[_this21.handWeightOptionOnce];
              _objKey = Object.keys(_this21.handWeightOptionData);
              for (_i = 0; _i < _objKey.length; _i++) {
                lastData.push.apply(lastData, _toConsumableArray(_this21.formartEditWeight(_this21.formateMantWeightData(_this21.handWeightOptionData[_objKey[_i]]))));
              }
              _context15.next = 7;
              return editManualScheme({
                list: lastData,
                type: 0
              });
            case 7:
              res = _context15.sent;
            case 8:
              _context15.next = 11;
              break;
            case 9:
              _context15.next = 10;
              return editPaymentLimitInfo({
                list: _this21.formartEditWeight(_this21.yesManyWeight),
                type: 0
              });
            case 10:
              res = _context15.sent;
            case 11:
              if (!res) {
                _context15.next = 14;
                break;
              }
              if (!(res.code === 0)) {
                _context15.next = 14;
                break;
              }
              _this21.$message.success(res.msg);
              if (!_this21.manyWeightDialog) {
                _context15.next = 13;
                break;
              }
              if (_this21.displayAddEditManyWeight) {
                _this21.displayAddEditManyWeight = false;
                _this21.handWeightOptionOnce = _this21.newSchemeName;
                _this21.newSchemeName = "";
              }
              _context15.next = 12;
              return _this21.getManyHandWeight();
            case 12:
              _context15.next = 14;
              break;
            case 13:
              _this21.manyWeightVisible = false;
              _this21.yesManyWeight = [];
            case 14:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    addMerchantWightConfim: function addMerchantWightConfim() {
      var _this22 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var sendData, i, merchantWeightChannl, j, res;
        return regeneratorRuntime.wrap(function (_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              sendData = {
                list: [],
                type: 0
              };
              for (i = 0; i < _this22.yesMerchantWeight.length; i++) {
                merchantWeightChannl = {
                  merchant_id: _this22.yesMerchantWeight[i].MerchantID
                };
                for (j = 0; j < _this22.yesMerchantWeight[i].channels.length; j++) {
                  merchantWeightChannl = _objectSpread(_objectSpread({}, merchantWeightChannl), _this22.yesMerchantWeight[i].channels[j]);
                  sendData.list.push(merchantWeightChannl);
                }
              }
              _context16.next = 1;
              return editWeightMerchantInfo(sendData);
            case 1:
              res = _context16.sent;
              if (res.code === 0) {
                _this22.$message.success(res.msg);
                _this22.getMerchantWeightInfo();
              }
            case 2:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    cancelAddLastLimitRate: function cancelAddLastLimitRate() {
      this.newSchemeName = "";
      this.displayAddEditManyWeight = false;
      this.getManyHandWeight();
    },
    /** @description 删除多权重方案 */delManyWeighOptionOnce: function delManyWeighOptionOnce() {
      this.yesManyWeight = [];
      this.addLastLimitRate(false);
    },
    deleteLimitRate: function deleteLimitRate(obj, index) {
      if (obj.channels.length === 0) {
        this.yesManyWeight.splice(index, 1);
      } else {
        this.$message.info("这个区间还有权重");
      }
    },
    deleteMerchantWight: function deleteMerchantWight(obj, index) {
      if (obj.channels.length === 0) {
        this.yesMerchantWeight.splice(index, 1);
      } else {
        this.$message.info("这个商户还有渠道");
      }
    },
    addTable: function addTable(method) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].method === method) {
          this.$message.warning("渠道已有");
          return;
        }
      }
      this.tableData.push({
        method: method,
        list: []
      });
    },
    // 添加修改成功率输入框
    addSuccessRate: function addSuccessRate() {
      var obj = {
        channels: [],
        max: "",
        method: this.editOneSuccessRateMethod,
        min: "",
        weight: ""
      };
      this.editOneSuccessRate.push(obj);
    },
    addLastSuccessRate: function addLastSuccessRate() {
      var _this23 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var i, j, res;
        return regeneratorRuntime.wrap(function (_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              if (!(_this23.editOneSuccessRate.length !== 0)) {
                _context17.next = 4;
                break;
              }
              if (!(_this23.calculateSuccessRate(_this23.editOneSuccessRate) === 1)) {
                _context17.next = 1;
                break;
              }
              _this23.$message.warning("区间需要从0开始");
              return _context17.abrupt("return");
            case 1:
              if (!(_this23.calculateSuccessRate(_this23.editOneSuccessRate) === 2)) {
                _context17.next = 2;
                break;
              }
              _this23.$message.warning("区间最大是100");
              return _context17.abrupt("return");
            case 2:
              if (!(_this23.calculateSuccessRate(_this23.editOneSuccessRate) === 3)) {
                _context17.next = 3;
                break;
              }
              _this23.$message.warning("最小成功率 要小于 最大成功率");
              return _context17.abrupt("return");
            case 3:
              if (!(_this23.editOneSuccessRate.length !== 1)) {
                _context17.next = 4;
                break;
              }
              if (_this23.calculateSuccessRate(_this23.editOneSuccessRate)) {
                _context17.next = 4;
                break;
              }
              _this23.$message.warning("请重新设置区间");
              return _context17.abrupt("return");
            case 4:
              _this23.successRateVisible = false;
              for (i = 0; i < _this23.editOneSuccessRate.length; i++) {
                for (j = 0; j < _this23.editOneSuccessRate[i].channels.length; j++) {
                  _this23.editOneSuccessRate[i].channels[j] = _this23.formatSuccessRate(_this23.editOneSuccessRate[i].channels[j]);
                }
              }
              _this23.editSuccessRate.list = [].concat(_toConsumableArray(_this23.editSuccessRate.list), _toConsumableArray(_this23.editOneSuccessRate));
              _context17.next = 5;
              return successRateLimit(_this23.editSuccessRate);
            case 5:
              res = _context17.sent;
              if (!(res.code === 0)) {
                _context17.next = 6;
                break;
              }
              _this23.$message.success("修改成功");
              _context17.next = 6;
              return _this23.getVoluntarilyTable();
            case 6:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    addAvailableChannl: function addAvailableChannl() {
      if (this.addOneChannel.length !== 2) {
        this.$message.error("请选择通道ID");
        return;
      }
      if (!this.maxCash) {
        this.$message.error("请输入最大代收限额");
        return;
      }
      this.channelsList.push({
        channel: this.addOneChannel[0].channel,
        payKey: this.addOneChannel[1],
        maxCash: this.maxCash
      });
      this.editAvailable();
      this.availableChannlVisble = false;
    },
    editWeightOnefn: function editWeightOnefn(tableIdx, listIdx, num, type) {
      if (num !== null) {
        if (type === 1) {
          this.tableData[tableIdx].list[listIdx].weight = num;
        }
      }
      this.displayindex = "";
    },
    formartEditWeight: function formartEditWeight(list) {
      var arr = [];
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < list[i].channels.length; j++) {
          var obj = {};
          obj["channel"] = list[i].channels[j].channel;
          obj["method"] = list[i].channels[j].method;
          obj["payKey"] = list[i].channels[j].payKey;
          obj["payOutLimitWeight"] = list[i].channels[j].payOutLimitWeight;
          obj["payOutLimitStart"] = list[i].payOutLimitStart;
          obj["payOutLimitEnd"] = list[i].payOutLimitEnd;
          if (this.displayAddEditManyWeight) {
            obj["schemeName"] = this.newSchemeName;
          }
          if (this.manyWeightDialog && list[0].schemeName) {
            obj["schemeName"] = list[0].schemeName;
          }
          arr.push(obj);
        }
      }
      return arr;
    },
    clearEditSuccessRate: function clearEditSuccessRate() {
      this.editSuccessRate = {
        list: [],
        type: 0
      };
      this.editOneSuccessRate = [];
      this.editOneSuccessRateMethod = "";
      this.editManyWeightBotton = false;
      this.handWeightOption = [];
      this.handWeightOptionOnce = "";
      this.handWeightOptionData = {};
      this.editManyWeightBotton = false;
      this.manyWeightDialog = false;
      this.manyWeightVisible = false;
      this.editManyWeightBotton = false;
      this.manyWeightDialog = false;
      this.displayAddEditManyWeight = false;
    },
    clearAvailableChannl: function clearAvailableChannl() {
      this.selectAddChannl = [];
      this.maxCash = null;
      this.addOneChannel = [];
    },
    dynamicallyLoadingData: function dynamicallyLoadingData(node, resolve) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var res, i;
        return regeneratorRuntime.wrap(function (_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              if (!(node.level === 1)) {
                _context18.next = 2;
                break;
              }
              _context18.next = 1;
              return gteChannelItem({
                ChannelId: node.data.channel
              });
            case 1:
              res = _context18.sent;
              if (res.code === 0) {
                if (res.data.list) {
                  for (i = 0; i < res.data.list.length; i++) {
                    if (res.data.list[i]["Type"] === "PAYOUT" || !res.data.list[i]["Status"]) {
                      res.data.list.splice(i, 1);
                      i = i - 1;
                    } else {
                      res.data.list[i]["select"] = res.data.list[i].ID;
                    }
                  }
                }
                resolve(res.data.list);
              }
              _context18.next = 3;
              break;
            case 2:
              resolve([]);
            case 3:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    // 计算成功率区间
    calculateSuccessRate: function calculateSuccessRate(list) {
      var maxList = [];
      var isZero = false;
      var isMinRateMaxRate = false;
      var maxRate = 0;
      var minRate = 0;
      for (var i = 0; i < list.length; i++) {
        if (!isZero && list[i]["min"] === 0) {
          isZero = true;
        }
        if (!isMinRateMaxRate && list[i]["max"] < list[i]["min"]) {
          isMinRateMaxRate = true;
          break;
        }
        maxRate = maxRate < list[i]["max"] ? list[i]["max"] : maxRate;
        minRate = minRate > list[i]["min"] ? list[i]["min"] : minRate;
        for (var j = 0; j < list.length; j++) {
          if (i === j && j !== list.length - 1) {
            j = j + 1;
          }
          if (list[i]["max"] === list[j]["min"]) {
            if (maxList.indexOf(i) < 0) {
              maxList.push(i);
            }
            if (maxList.indexOf(j) < 0) {
              maxList.push(j);
            }
            break;
          }
        }
      }
      if (!isZero || minRate < 0) {
        return 1;
      } else if (maxRate > 100) {
        return 2;
      } else if (isMinRateMaxRate) {
        return 3;
      } else return list.length === maxList.length;
    },
    deleteSuccessRate: function deleteSuccessRate(obj, index) {
      if (obj.channels.length === 0) {
        this.editOneSuccessRate.splice(index, 1);
      } else {
        this.$message.info("这个区间还有渠道");
      }
    },
    formatSuccessRate: function formatSuccessRate(obj) {
      var lastObj = {
        channel: 0,
        payKey: ""
      };
      var lastObjKey = Object.keys(lastObj);
      for (var i = 0; i < lastObjKey.length; i++) {
        lastObj[lastObjKey[i]] = obj[lastObjKey[i]];
      }
      return lastObj;
    },
    formatWeight: function formatWeight(obj) {
      var lastObj;
      if (this.showAuto === 4) {
        lastObj = {
          channel: 0,
          method: "",
          payKey: "",
          weight: "",
          schemeName: ""
        };
      } else {
        lastObj = {
          channel: 0,
          method: "",
          payKey: "",
          weight: ""
        };
      }
      var lastObjKey = Object.keys(lastObj);
      for (var i = 0; i < lastObjKey.length; i++) {
        lastObj[lastObjKey[i]] = obj[lastObjKey[i]];
      }
      return lastObj;
    },
    // 拖拽函数
    groupSuccessRateEnd: function groupSuccessRateEnd() {
      var editChannl = {};
      var editIndex = 0;
      var editMethdIndex = 0;
      var flag = false;
      for (var i = 0; i < this.editOneSuccessRate.length; i++) {
        for (var k = 0; k < this.editOneSuccessRate[i].channels.length; k++) {
          if (this.editOneSuccessRate[i].channels[k].maxCash) {
            editIndex = i;
            editMethdIndex = k;
            editChannl = this.editOneSuccessRate[i].channels[k];
            break;
          }
          if (editChannl.maxCash) {
            break;
          }
        }
        for (var _i2 = 0; _i2 < this.editOneSuccessRate.length; _i2++) {
          for (var _k = 0; _k < this.editOneSuccessRate[_i2].channels.length; _k++) {
            if (editMethdIndex !== _k || editIndex !== _i2) {
              if (this.editOneSuccessRate[_i2].channels[_k].payKey === editChannl.payKey) {
                this.editOneSuccessRate[editIndex].channels.splice(editMethdIndex, 1);
                this.$message.warning("通道已有");
                flag = true;
                break;
              }
            }
          }
          if (flag) break;
        }
      }
    },
    groupLimitRateEnd: function groupLimitRateEnd() {
      var editChannl = {};
      var editIndex = 0;
      var outLimitEnd = null;
      var outLimitStart = null;
      var editMethdIndex = 0;
      var flag = false;
      for (var i = 0; i < this.yesManyWeight.length; i++) {
        for (var k = 0; k < this.yesManyWeight[i].channels.length; k++) {
          if (!this.yesManyWeight[i].channels[k]["falg"]) {
            editIndex = i;
            editMethdIndex = k;
            outLimitStart = this.yesManyWeight[i].payOutLimitStart;
            outLimitEnd = this.yesManyWeight[i].payOutLimitEnd;
            this.yesManyWeight[i].channels[k]["falg"] = true;
            this.yesManyWeight[i].channels[k].payOutLimitWeight = 0;
            editChannl = this.yesManyWeight[i].channels[k];
            break;
          }
        }
      }
      for (var j = 0; j < this.yesManyWeight[editIndex].channels.length; j++) {
        if (editMethdIndex !== j) {
          if (this.yesManyWeight[editIndex].channels[j].payKey === editChannl.payKey && this.yesManyWeight[editIndex].channels[j].method === editChannl.method) {
            console.log("editMethdIndex", editMethdIndex, "\neditIndex", editIndex);
            this.yesManyWeight[editIndex].channels.splice(editMethdIndex, 1);
            this.$message.warning("这个区间通道已有");
            flag = true;
            break;
          }
        }
      }
      for (var _i3 = 0; _i3 < this.notManyWeight.length; _i3++) {
        this.notManyWeight[_i3].falg = false;
      }
    },
    groupMerchantEnd: function groupMerchantEnd() {
      for (var i = 0; i < this.yesMerchantWeight.length; i++) {
        for (var k = 0; k < this.yesMerchantWeight[i].channels.length; k++) {
          this.yesManyWeight[i].channels[k].weight = 0;
          break;
        }
      }
    },
    grouptableEnd: function grouptableEnd() {
      var editIndex = 0;
      var editMethdIndex = 0;
      var editMethod = "";
      var editChannl = {};
      var flag = false;
      for (var i = 0; i < this.tableData.length; i++) {
        for (var j = 0; this.tableData[i].list.length; j++) {
          if (!this.tableData[i].list[j]) break;
          if (this.tableData[i].list[j]["maxCash"]) {
            editMethod = this.tableData[i].method;
            editIndex = i;
            editMethdIndex = j;
            editChannl = this.tableData[i].list[j];
            break;
          }
        }
        if (editMethod) {
          break;
        }
      }
      for (var _j = 0; _j < this.tableData[editIndex].list.length; _j++) {
        if (editMethdIndex !== _j) {
          if (this.tableData[editIndex].list[_j].payKey === editChannl.payKey) {
            this.tableData[editIndex].list.splice(editMethdIndex, 1);
            this.tableKey = Math.random(1000);
            this.$message.warning("通道已有");
            flag = true;
            break;
          }
        }
        if (flag) break;
      }
      if (!flag) {
        var list = this.tableData[editIndex].list[editMethdIndex];
        this.tableData[editIndex].list.splice(editMethdIndex, 1);
        list.weight = 0;
        if (this.showAuto !== 4) {
          list["maxPayInCash"] = list.maxCash;
          list["type"] = 0;
          list["typeStr"] = "代收通道";
          list["number"] = this.tableData.length;
        } else {
          list["schemeName"] = this.handWeightOptionOnce;
        }
        this.tableData[editIndex]["list"].push(list);
        this.tableKey = Math.random(1000);
        // this.tableData = list
        // console.log(list)
        // this.editWeightfn()
      }
    },
    clone: function clone(origin) {
      return JSON.parse(JSON.stringify(origin));
    },
    arraySpanMethod: function arraySpanMethod(_ref3) {
      var row = _ref3.row,
        column = _ref3.column,
        rowIndex = _ref3.rowIndex,
        columnIndex = _ref3.columnIndex;
      for (var j = 0; j < this.tableData.length; j++) {
        if (this.tableData[j].method === row.method) {
          var tablelist = this.tableData[j].list;
          if (columnIndex === 0) {
            // 第一列，按level合并
            if (rowIndex === 0 || row.level !== tablelist[rowIndex - 1].level) {
              // 当前行是第一行，或者与上一行level不同，需要合并
              var count = 1;
              for (var i = rowIndex + 1; i < tablelist.length; i++) {
                if (tablelist[i].level === row.level) {
                  count++;
                } else {
                  break;
                }
              }
              return {
                rowspan: count,
                colspan: 1
              };
            } else {
              // 与上一行相同，不需要渲染
              return {
                rowspan: 0,
                colspan: 0
              };
            }
          }
          if (columnIndex === 1) {
            if (rowIndex === 0 || row.level !== tablelist[rowIndex - 1].level) {
              var _count = 1;
              for (var _i4 = rowIndex + 1; _i4 < tablelist.length; _i4++) {
                if (tablelist[_i4].level === row.level && tablelist[_i4].weight === row.weight) {
                  _count++;
                } else {
                  break;
                }
              }
              return {
                rowspan: _count,
                colspan: 1
              };
            } else {
              // 与上一行相同，不需要渲染
              return {
                rowspan: 0,
                colspan: 0
              };
            }
          }
          break;
        }
      }
    }
  }
};